import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, ButtonToolbar, Spinner } from 'react-bootstrap';
import { useTranslationWithRef } from '../../hooks/useTranslationWithRef';
import { getAllConsents, getConsent, saveConsents } from '../../api/ShoppingCart';
import Consent from '../../api/models/Consent';
import { APIError } from '../../api/ObservableFromFetch';
import { toast } from 'react-toastify';
import ConsentForm from '../Results/Modals/ConsentForm';
import { Subscription } from 'rxjs';
import OrderItem from '../../api/models/addOnTesting/ShoppingCart';

interface ConsentProps {
  cartItems: OrderItem[]
  testEventId: number
  onBack: () => void
  onSubmit: () => void
}

export const ConsentStep = (props: ConsentProps) => {
  const [translationRef, t] = useTranslationWithRef()
  const [loading, setLoading] = useState(true)
  const [consents, setConsents] = useState<Consent[]>([])
  const [acceptedConsents, setAcceptedConsents] = useState<number[]>([])

  useEffect(() => {
    const subscription = getAllConsents(props.testEventId).subscribe({
      next: (results: Consent[]) => {
        setConsents(results)
        setLoading(false)
      },
      error: (e: APIError) => {
        setLoading(false)
        toast.error(translationRef.current(e.message, { data: e.data }))
      }
    })
    return () => subscription.unsubscribe()
  }, [translationRef])

  const subsriptionRef = useRef<Subscription | undefined>(undefined)

  const saveConsent = (values: number[]) => {
    if (subsriptionRef.current) {
      subsriptionRef.current.unsubscribe()
    }
    subsriptionRef.current = saveConsents({id: props.testEventId, ids: values}).subscribe({
      next: (results: Consent[]) => {
        // TODO: check results.length === 0 and redirect to next step
      },
      error: (e: APIError) => {
        toast.error(t(e.message, { data: e.data }))
      }
    })
  }

  const sortedCartItems = useMemo(() => props.cartItems.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name)), [props.cartItems])

  return (
  <>
    <h4 className="text-center">{sortedCartItems.map(item => item.name).toString()}</h4>
    {loading && <Spinner animation="border" role="status" size="sm" className="mx-1" />}
    {!loading && consents.length > 0 && consents.map(consent => <ConsentForm key={consent.consentId} consent={consent} implementation={undefined}
      initialAccepted={false} onCancel={() => { }} onSubmit={() => { }}
      onChange={(accepted) => setAcceptedConsents(accepted ? [...acceptedConsents, consent.consentId] : acceptedConsents.filter(consentId => consentId !== consent.consentId))}
    />)}
    <ButtonToolbar className="justify-content-between">
      <Button variant="secondary" onClick={() => props.onBack()}>{t('shoppingCart.back')}</Button>
      <Button disabled={consents.length === 0 || acceptedConsents.length !== consents.length} onClick={() => {
        saveConsent(acceptedConsents)
        props.onSubmit()}
      }>{t('shoppingCart.nextStep')}</Button>
    </ButtonToolbar>
  </>
  )
}
